import * as XLSX from "xlsx";
import { iProjectQa, iProPermission } from "../models/interfaceProject";

export const getExcelReadColumns = (file: File): Promise<string[]> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = (e: ProgressEvent<FileReader>) => {
      try {
        const data = new Uint8Array(e.target?.result as ArrayBuffer);
        const workbook = XLSX.read(data, { type: "array" });
        const sheetName = workbook.SheetNames[0];
        const sheet = workbook.Sheets[sheetName];
        const firstRow = XLSX.utils.sheet_to_json(sheet, { header: 1 })[0] as string[];
        resolve(Array.isArray(firstRow) ? firstRow : []);
      } catch (error) {
        reject(error);
      }
    };

    reader.onerror = (error) => reject(error);
    reader.readAsArrayBuffer(file);
  });
};



export const getExcelReadFirstColumn = (file: File): Promise<string[]> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = (e: ProgressEvent<FileReader>) => {
      try {
        const data = new Uint8Array(e.target?.result as ArrayBuffer);
        const workbook = XLSX.read(data, { type: "array" });

        const sheetName = workbook.SheetNames[0];
        const sheet = workbook.Sheets[sheetName]; 
        const rows = XLSX.utils.sheet_to_json(sheet, {
          header: 1,
          defval: "",
        }) as string[][]; 
        const dataRows = rows.slice(1); 
        const values = dataRows
          .flat()
          .map((v) => String(v).trim())
          .filter(Boolean);

        resolve(values);
      } catch (error) {
        reject(error);
      }
    };

    reader.onerror = (error) => reject(error);
    reader.readAsArrayBuffer(file);
  });
};




export const getExcelQa = (file: File): Promise<iProjectQa[]> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = (e: ProgressEvent<FileReader>) => {
      try {
        const data = new Uint8Array(e.target?.result as ArrayBuffer);
        const workbook = XLSX.read(data, { type: "array" });
        const sheetName = workbook.SheetNames[0]; // Toma la primera hoja
        const sheet = workbook.Sheets[sheetName];
        const jsonData: any[] = XLSX.utils.sheet_to_json(sheet, { header: 1 });

        // Convertir a iProjectQa[] y eliminar filas vacías
        const qaData: iProjectQa[] = jsonData
          .slice(1) // Omitir la cabecera
          .filter((row) => row[0]?.toString().trim() || row[1]?.toString().trim()) // Elimina filas vacías
          .map((row) => ({
            chunk_overlap: "1",
            chunk_size: "6000",
            question: row[0]?.toString() || "",
            answer: row[1]?.toString() || "",
            deleted: false,
            edit: false,
            qa_id_local: crypto.randomUUID(),
          }));

        resolve(qaData);
      } catch (error) {
        reject(error);
      }
    };

    reader.onerror = (error) => reject(error);
    reader.readAsArrayBuffer(file);
  });
};



export const getExcelPermissions = (file: File): Promise<iProPermission[]> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader(); 
    reader.onload = (e: ProgressEvent<FileReader>) => {
      try {
        const data = new Uint8Array(e.target?.result as ArrayBuffer);
        const workbook = XLSX.read(data, { type: "array" });
        const sheetName = workbook.SheetNames[0];
        const sheet = workbook.Sheets[sheetName];
        const jsonData: any[] = XLSX.utils.sheet_to_json(sheet, { header: 1 });

        // Convertir a iProPermission[] y eliminar filas vacías
        const permissionData: iProPermission[] = jsonData
          .slice(1) // Omitir la cabecera
          .filter((row) => row[0]?.toString().trim() || row[1]?.toString().trim()) // Elimina filas vacías
          .map((row) => ({
            //domain: string,
            email: row[0]?.toString().toLowerCase(),
            new:true,
            administrator:false
          })); 
        resolve(permissionData);
      } catch (error) {
        reject(error);
      }
    };

    reader.onerror = (error) => reject(error);
    reader.readAsArrayBuffer(file);
  });
};


/*
export const getExcelQa = (file: File): Promise<iProjectQa[]> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = (e: ProgressEvent<FileReader>) => {
      try {
        const data = new Uint8Array(e.target?.result as ArrayBuffer);
        const workbook = XLSX.read(data, { type: "array" }); 
        const sheetName = workbook.SheetNames[0]; // Toma la primera hoja
        const sheet = workbook.Sheets[sheetName]; 
        const jsonData: any[] = XLSX.utils.sheet_to_json(sheet, { header: 1 }); 
        // Convertir a iProjectQa[]
        const qaData: iProjectQa[] = jsonData.slice(1).map((row) => ({
          chunk_overlap: "1",
          chunk_size: "6000",
          question: ""+row[0] || "",
          answer: ""+row[1] || "",
          deleted: false,
          edit:false,
          qa_id_local:crypto.randomUUID()

        }));

        resolve(qaData);
      } catch (error) {
        reject(error);
      }
    };

    reader.onerror = (error) => reject(error);
    reader.readAsArrayBuffer(file);
  });
};


*/